import dayjs from "dayjs";

export const formatBundleDateTime = (value: string) => `${dayjs.utc(value).format("DD MMM YYYY, HH:mm")} UTC`;
